import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './IconContainer.css';

import Add from '../../../icons/Add';
import CheckBox from '../../../icons/CheckBox';
import CheckBoxOutlineBlank from '../../../icons/CheckBoxOutlineBlank';
import Clear from '../../../icons/Clear';
import Create from '../../../icons/Create';
import Info from '../../../icons/Info';
import Person from '../../../icons/Person';
import RadioButtonChecked from '../../../icons/RadioButtonChecked';
import RadioButtonUnchecked from '../../../icons/RadioButtonUnchecked';
import ArrowBack from '../../../icons/ArrowBack';
import QuestionMark from "../../../icons/QuestionMark";
import KeyboardArrowRight from '../../../icons/KeyboardArrowRight';
import KeyboardArrowDown from '../../../icons/KeyboardArrowDown';
import Certify from '../../../icons/Certify';
import Search from '../../../icons/Search';
import Visibility from '../../../icons/Visibility';
import CheckCircleOutline from '../../../icons/CheckCircleOutline';
import HighlightOff from '../../../icons/HighlightOff';
import Book from '../../../icons/Book';
import Trash from '../../../icons/Trash';
import NotificationCircle from "../../../icons/NotificationCircle";
import Restore from "../../../icons/Restore";
import Lock from "../../../icons/Lock";
import Save from "../../../icons/Save";
import Payment from "../../../icons/Payment";
import PlayCircleOutline from "../../../icons/PlayCircleOutline";
import AddYear from "../../../icons/AddYear";

const ICONS_MAP = {
    add: Add,
    check_box: CheckBox,
    check_box_outline_blank: CheckBoxOutlineBlank,
    clear: Clear,
    create: Create,
    info: Info,
    person: Person,
    radio_button_checked: RadioButtonChecked,
    radio_button_unchecked: RadioButtonUnchecked,
    arrow_back: ArrowBack,
    question_mark: QuestionMark,
    keyboard_arrow_right: KeyboardArrowRight,
    keyboard_arrow_down: KeyboardArrowDown,
    certify: Certify,
    search: Search,
    visibility: Visibility,
    check_circle_outline: CheckCircleOutline,
    highlight_off: HighlightOff,
    book: Book,
    trash: Trash,
    notification_circle: NotificationCircle,
    restore: Restore,
    lock: Lock,
    save: Save,
    payment: Payment,
    play_circle_outline: PlayCircleOutline,
    add_year: AddYear
};

class IconContainer extends Component {
    render() {
        const TagName = ICONS_MAP[this.props.icon];

        if (_.isNil(this.props.icon) || _.isNil(ICONS_MAP[this.props.icon])){
            return null;
        } else {
            return (
                <div className={ "icon-container-component " + (!_.isNil(this.props.className) ? this.props.className : "")} title={this.props.title} onClick={this.props.onClick}>
                    <TagName />
                </div>
            );
        }
    }
}

IconContainer.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export default IconContainer;



// WEBPACK FOOTER //
// ./src/components/commonComponents/iconContainer/IconContainer.js